<template>
<div class="empty">
    <div class="icon"></div>
    <template v-if="!searchingProps.status">
        <p>这里什么都没有~</p>
    </template>
    <template v-else>
        <p>没有搜索到“{{searchingProps.keyVal}}”相关的{{searchingProps.type}}</p>
        <p class="text-small">将素材需求反馈给我们 <br>
有助于我们优化素材库哦</p>
    </template>
    <slot name="btn"></slot>
</div>
</template>
<script>
export default {
    name: 'Empty',
    props: {
        searchingProps: {
            type: Object,
            default () {
                return {
                    status: false,
                    keyVal: '',
                    type: '模板'
                }
            }
        }
    },
    data () {
        return {}
    },
    created() {
    },
}
</script>
<style lang="scss" scoped>
.empty {
    height: 100%;
    display: flex;
    margin: auto;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .icon {
        width: 101px;
        height: 90px;
        background-image: url("../../../static/img/empty.png");
        background-position: 0 0;
        background-size: 100% 100%;
    }
    p {
      margin-top: 10px;
      line-height: 16px;
      font-size: 14px;
      color: #474261;
      &.text-small {
        font-size: 12px;
        color: #999;
        margin-bottom: 20px;
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/common/empty.vue